export function createMmdWasmInstance() {
    return import("./wasm");
}
